/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Box, Typography } from '@mui/material';

import {
  CollapsibleTableData,
  CollapsibleTableRow,
} from '@Components/CollapsibleTable';
import { DialSubSession, SessionsSummaryTable } from '@Models/report.model';

/** Returns data for table row in desired format. */
export const createData = (
  row: SessionsSummaryTable,
  modalBtn: (id: string, text: string) => JSX.Element
): CollapsibleTableData => {
  const {
    id,
    listName,
    createdAt,
    calls,
    contacted,
    noAnswer,
    duration,
    totalTime,
    dialSubSessions,
  } = row;

  return {
    primaryData: {
      sessionName: (
        <Box>
          {modalBtn(id, listName)}
          <Typography variant="main" sx={{ color: 'text.secondary' }}>
            {id}
          </Typography>
        </Box>
      ),
      sessionDate: <Typography variant="main">{createdAt}</Typography>,
      totalTime,
      calls,
      contacted,
      noAnswer,
      duration,
      idOpenControl: id,
    },
    collapsibleData: (dialSubSessions as unknown as DialSubSession[]).map(
      (item) => ({
        primaryData: {
          sessionName: (
            <Typography variant="main" sx={{ color: 'text.secondary' }}>
              {item.dialSubSessionId}
            </Typography>
          ),
          sessionDate: <Typography variant="main">{item.createdAt}</Typography>,
          totalTime: item.totalTime,
          calls: item.calls,
          contacted: item.contacted,
          noAnswer: item.noAnswer,
          duration: item.duration,
        },
      })
    ),
  };
};

/** Returns Map of Grouped Data according to passed key.
 * @param table - table data
 * @param key - key according to which group is to be created
 */
export const getGroupedRows = (
  table: SessionsSummaryTable[],
  key: keyof SessionsSummaryTable
): Map<string, SessionsSummaryTable[]> => {
  const groupedMap = table.reduce(
    (entryMap: Map<string, SessionsSummaryTable[]>, e) =>
      entryMap.set(e[key] as unknown as string, [
        ...(entryMap.get(e[key] as unknown as string) || []),
        e,
      ]),
    new Map()
  );

  return groupedMap;
};

/** Returns Rows for Collapsible Table (Call Log) */
export const GetRows = (
  table: SessionsSummaryTable[] = [],
  modalBtn: (id: string, text: string) => JSX.Element
): {
  rows: CollapsibleTableRow[];
  groupedMap: Map<string, SessionsSummaryTable[]>;
} => {
  const rows: CollapsibleTableRow[] = [];

  const groupedMap = getGroupedRows(table, 'accountName');

  groupedMap.forEach((group, key) => {
    rows.push({
      id: key,
      name: key,
      data: group.map((row) => createData(row, modalBtn)),
    });
  });

  return { rows, groupedMap };
};

/** Returns list of nested session ids of selected rows */
export const getListOfSessionIds = (
  tableCheckboxChecked: readonly string[],
  groupedMap: Map<string, SessionsSummaryTable[]>
): string[] =>
  tableCheckboxChecked
    .map((name) => groupedMap.get(name))
    .flatMap((sessionSummaryTableArr) =>
      sessionSummaryTableArr?.map((sessionSummary) => sessionSummary.id)
    ) as string[];
